import BaseModel from './BaseModel';

/** Class representing an user. */
class Rate extends BaseModel {}

export default Rate;
